import { useState, useEffect, useRef, useCallback } from "react";
import logo from '../assest/logo2.png';
import logo2 from "../assest/brand-logo.png";
import CharacterDisplay from "../pages/CharacterDisplay";

const ELEVENLABS_API_KEY = "sk_386c047760948d74a623b67633f480e34d4b5c9f5dd0e45b";
const VOICE_ID = "JBFqnCBsd6RMkjVDRZzb";

async function elevenLabsTTS(text) {
    const res = await fetch(`https://api.elevenlabs.io/v1/text-to-speech/${VOICE_ID}`, {
        method: "POST",
        headers: {
            "xi-api-key": ELEVENLABS_API_KEY,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            text,
            model_id: "eleven_multilingual_v2",
            voice_settings: { stability: 0.5, similarity_boost: 0.75 },
        }),
    });
    if (!res.ok) throw new Error(`TTS failed: ${res.status}`);
    const blob = await res.blob();
    return URL.createObjectURL(blob);
}

async function elevenLabsSTT(audioBlob) {
    const formData = new FormData();
    formData.append("file", audioBlob, "recording.webm");
    formData.append("model_id", "scribe_v1");

    const res = await fetch("https://api.elevenlabs.io/v1/speech-to-text", {
        method: "POST",
        headers: { "xi-api-key": ELEVENLABS_API_KEY },
        body: formData,
    });
    if (!res.ok) throw new Error(`STT failed: ${res.status}`);
    const data = await res.json();
    return data.text?.trim() || "";
}

// ─── Keyframes (unchanged) ────────────────────────────────────────────────────
const KEYFRAMES = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap');
  @keyframes nb-float-a  { 0%,100%{transform:translate(0,0) scale(1)} 40%{transform:translate(20px,-32px) scale(1.04)} 70%{transform:translate(-16px,16px) scale(.97)} }
  @keyframes nb-float-b  { 0%,100%{transform:translate(0,0) scale(1)} 35%{transform:translate(-38px,24px) scale(1.06)} 65%{transform:translate(30px,-14px) scale(.95)} }
  @keyframes nb-ring     { 0%,100%{transform:scale(.88);opacity:.9} 50%{transform:scale(1.15);opacity:.25} }
  @keyframes nb-rise     { from{opacity:0;transform:translateY(18px)} to{opacity:1;transform:translateY(0)} }
  @keyframes nb-bob-idle { 0%,100%{transform:translateY(0) rotate(-1.5deg)} 50%{transform:translateY(-8px) rotate(1.5deg)} }
  @keyframes nb-scan     { 0%{top:0;opacity:.7} 50%{opacity:1} 100%{top:100%;opacity:.7} }
  @keyframes nb-breathe  { 0%,100%{transform:scale(1)} 50%{transform:scale(1.022)} }
  @keyframes nb-star     { 0%,100%{opacity:.06} 50%{opacity:.44} }
  @keyframes nb-particle { 0%{transform:translateY(0) scale(1);opacity:.7} 100%{transform:translateY(-60px) scale(.4);opacity:0} }
  @keyframes nb-modal-in { from{opacity:0;transform:scale(.96) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }
  @keyframes nb-card-in  { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
  @keyframes nb-shimmer  { 0%{background-position:-200% center} 100%{background-position:200% center} }
  @keyframes nb-typing   { 0%{opacity:0.4;transform:translateY(0)} 50%{opacity:1;transform:translateY(-4px)} 100%{opacity:0.4;transform:translateY(0)} }
  .nb-float-a  { animation: nb-float-a  16s ease-in-out infinite }
  .nb-float-b  { animation: nb-float-b  20s ease-in-out infinite }
  .nb-ring     { animation: nb-ring      2.2s ease-in-out infinite }
  .nb-rise     { animation: nb-rise      .5s cubic-bezier(.16,1,.3,1) both }
  .nb-bob-idle { animation: nb-bob-idle  4.5s ease-in-out infinite }
  .nb-breathe  { animation: nb-breathe   3.5s ease-in-out infinite }
  .nb-modal-in { animation: nb-modal-in  .4s cubic-bezier(.16,1,.3,1) both }
  .nb-card-in  { animation: nb-card-in   .4s both }
  .nb-grad-text {
    background: linear-gradient(130deg,#60a5fa,#c084fc,#60a5fa);
    background-size: 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: nb-shimmer 4s linear infinite;
  }
  .nb-font { font-family: 'Plus Jakarta Sans', sans-serif; }
  .nb-mono { font-family: 'JetBrains Mono', monospace; }
`;

// ─── Sub-components ───────────────────────────────────────────────────────────
function ModalBg({ state }) {
    // const orb1 = state === "speaking" ? "rgba(16,185,129,.15)" : state === "listening" ? "rgba(239,68,68,.13)" : "rgba(37,99,235,.12)";
    // const orb2 = state === "thinking" ? "rgba(245,158,11,.12)" : "rgba(124,58,237,.11)";
    const stars = Array.from({ length: 22 }, (_, i) => ({ x: (i * 37 + 13) % 100, y: (i * 53 + 9) % 100, r: i % 5 === 0 ? 1.5 : 1, d: (i * 0.27) % 4, dur: 2 + (i % 3) }));
    return (
        <div className="absolute inset-0 overflow-hidden rounded-2xl">
            <div className="absolute inset-0 rounded-2xl" style={{ background: "white" }} />
            <div className="absolute inset-0 rounded-2xl" style={{ backgroundImage: "linear-gradient(rgba(96,165,250,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(96,165,250,.025) 1px,transparent 1px)", backgroundSize: "56px 56px" }} />
            {/* <div className="absolute rounded-full nb-float-a" style={{ width: 500, height: 500, left: -160, top: -160, background: `radial-gradient(circle,${orb1} 0%,transparent 68%)`, transition: "background 1.2s ease" }} /> */}
            {/* <div className="absolute rounded-full nb-float-b" style={{ width: 440, height: 440, right: -120, bottom: -100, background: `radial-gradient(circle,${orb2} 0%,transparent 68%)`, transition: "background 1.2s ease" }} /> */}
            {state === "thinking" && (
                <div className="absolute left-0 right-0" style={{ height: 1, background: "linear-gradient(90deg,transparent,rgba(245,158,11,.45),transparent)", animation: "nb-scan 2.2s linear infinite" }} />
            )}
            {stars.map((s, i) => (
                <div key={i} className="absolute rounded-full bg-white" style={{ width: s.r * 2, height: s.r * 2, left: `${s.x}%`, top: `${s.y}%`, animation: `nb-star ${s.dur}s ${s.d}s ease-in-out infinite`, opacity: 0.06 }} />
            ))}
        </div>
    );
}

function MicBtn({ state, onClick }) {
    const isListening = state === "listening";
    const isDisabled = state === "thinking" || state === "speaking";
    return (
        <div className="relative flex items-center justify-center">
            {isListening && [1, 2].map((i) => (
                <div key={i} className="absolute rounded-full nb-ring" style={{ inset: -(i * 14), border: "1px solid rgba(239,68,68,.18)" }} />
            ))}
            <button onClick={onClick} disabled={isDisabled}
                className="flex items-center justify-center rounded-full transition-all duration-200 bg-gradient-to-r from-[#B03982] to-[#733C86]"
                style={{ width: 72, height: 72, border: isListening ? "2px solid rgba(239,68,68,.6)" : "2px solid rgba(96,165,250,.28)", cursor: isDisabled ? "not-allowed" : "pointer", opacity: isDisabled ? 0.35 : 1 }}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill={isListening ? "white" : "none"} stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="9" y="2" width="6" height="12" rx="3" fill={isListening ? "white" : "none"} />
                    <path d="M5 10a7 7 0 0 0 14 0" /><line x1="12" y1="17" x2="12" y2="21" /><line x1="8" y1="21" x2="16" y2="21" />
                </svg>
            </button>
        </div>
    );
}

function TypingAnimation() {
    return (
        <div className="flex gap-1.5 items-center py-2 px-4 rounded-full" style={{ background: "rgba(255,255,255,.05)" }}>
            {[0, 0.2, 0.4].map((delay, i) => (
                <div key={i} className="w-2 h-2 rounded-full bg-slate-400" style={{ animation: `nb-typing 1.2s ease-in-out ${delay}s infinite` }} />
            ))}
        </div>
    );
}

function MessageBubble({ role, content, isStreaming = false }) {
    const isUser = role === "user";
    return (
        <div className={`flex ${isUser ? "justify-end" : "justify-start"} nb-card-in`}>
            <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 ${isUser ? "bg-gradient-to-r from-[#B03982] to-[#733C86] text-white" : "bg-white/10 backdrop-blur-sm border border-white/20 text-gray-900"}`}>
                {isStreaming ? <TypingAnimation /> : <p className="text-sm leading-relaxed whitespace-pre-wrap break-words">{content}</p>}
            </div>
        </div>
    );
}

const generateAIResponse = async (userMessage) => {
    // Use free Groq API - super fast, no credit card needed
    const res = await fetch("https://api.groq.com/openai/v1/chat/completions", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer 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",
        },
        body: JSON.stringify({
            model: "llama-3.1-8b-instant",
            max_tokens: 150,
            messages: [
                {
                    role: "system",
                    content: "You are Nerdy Buddy, a friendly kiosk assistant. Answer in 1-2 short sentences only."
                },
                { role: "user", content: userMessage }
            ],
        }),
    });
    if (!res.ok) throw new Error(`AI error: ${res.status}`);
    const data = await res.json();
    return data.choices[0].message.content;
};

// ─── Main Modal ───────────────────────────────────────────────────────────────
function NerdyBuddyModal({ onClose }) {

    const [appState, setAppState] = useState("idle");
    const [messages, setMessages] = useState([
        {
            role: "assistant",
            content: "Hey, you are looking awesome today. I am an AI based, intelligent being, developed in the UK. I am mastering your company's regulations so I can assist you and your other fellows. Would you like to ask me a question?",
            timestamp: Date.now()
        }
    ]);
    const [inputVal, setInputVal] = useState("");
    const [error, setError] = useState(null);
    const [particles, setParticles] = useState([]);
    const [isGenerating, setIsGenerating] = useState(false);

    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const streamRef = useRef(null);
    const ttsAudioRef = useRef(null);
    const inputRef = useRef(null);
    const messagesEndRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages, isGenerating]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            stopRecording();
            cleanupTTS();
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (appState === "speaking") {
            setParticles(Array.from({ length: 8 }, (_, i) => ({ id: i, x: 32 + Math.random() * 36, delay: Math.random() * 1.2, size: 3 + Math.random() * 3 })));
        } else {
            setParticles([]);
        }
    }, [appState]);

    const cleanupTTS = () => {
        if (ttsAudioRef.current) {
            ttsAudioRef.current.pause();
            URL.revokeObjectURL(ttsAudioRef.current.src);
            ttsAudioRef.current = null;
        }
    };

    const stopRecording = useCallback(() => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
            mediaRecorderRef.current.stop();
        }
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(t => t.stop());
            streamRef.current = null;
        }
    }, []);

    // ── ElevenLabs TTS ─────────────────────────────────────────────────────
    const speakAnswer = useCallback(async (text) => {
        setAppState("speaking");
        cleanupTTS();
        try {
            const audioUrl = await elevenLabsTTS(text);
            const audio = new Audio(audioUrl);
            ttsAudioRef.current = audio;
            await new Promise((resolve, reject) => {
                audio.onended = resolve;
                audio.onerror = reject;
                audio.play();
            });
        } catch (err) {
            console.error("TTS error, falling back to browser speech:", err);
            // Graceful fallback to Web Speech API
            const utt = new SpeechSynthesisUtterance(text);
            utt.rate = 0.94; utt.pitch = 1.1;
            window.speechSynthesis.speak(utt);
            await new Promise(resolve => { utt.onend = resolve; utt.onerror = resolve; });
        } finally {
            setAppState("idle");
        }
    }, []);

    // ── Shared pipeline: AI response → TTS ─────────────────────────────────
    const runAIPipeline = useCallback(async (userText) => {
        setIsGenerating(true);
        setAppState("thinking");
        try {
            const aiResponse = await generateAIResponse(userText);
            setMessages(prev => [...prev, { role: "assistant", content: aiResponse, timestamp: Date.now() }]);
            await speakAnswer(aiResponse);
        } catch (err) {
            console.error("Pipeline error:", err);
            setError("Sorry, something went wrong. Please try again.");
            setMessages(prev => [...prev, { role: "assistant", content: "I'm experiencing some technical difficulties. Could you try again? 🙏", timestamp: Date.now() }]);
            setAppState("idle");
        } finally {
            setIsGenerating(false);
        }
    }, [speakAnswer]);

    // ── Text submit ─────────────────────────────────────────────────────────
    const processUserInput = useCallback(async (userText) => {
        if (!userText.trim() || isGenerating) return;
        setMessages(prev => [...prev, { role: "user", content: userText.trim(), timestamp: Date.now() }]);
        setInputVal("");
        setError(null);
        await runAIPipeline(userText.trim());
    }, [isGenerating, runAIPipeline]);

    const handleTextSubmit = () => {
        if (!inputVal.trim() || appState !== "idle" || isGenerating) return;
        processUserInput(inputVal);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleTextSubmit(); }
    };

    // ── ElevenLabs STT via REST ─────────────────────────────────────────────
    const startListening = useCallback(async () => {
        if (appState !== "idle" || isGenerating) return;
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            streamRef.current = stream;

            // Pick best supported format
            const mimeType = MediaRecorder.isTypeSupported("audio/webm;codecs=opus")
                ? "audio/webm;codecs=opus"
                : MediaRecorder.isTypeSupported("audio/webm")
                    ? "audio/webm"
                    : "audio/ogg";

            const mediaRecorder = new MediaRecorder(stream, { mimeType });
            mediaRecorderRef.current = mediaRecorder;
            audioChunksRef.current = [];

            mediaRecorder.ondataavailable = (e) => {
                if (e.data.size > 0) audioChunksRef.current.push(e.data);
            };

            mediaRecorder.onstop = async () => {
                // Stop mic tracks
                if (streamRef.current) {
                    streamRef.current.getTracks().forEach(t => t.stop());
                    streamRef.current = null;
                }
                setAppState("thinking");
                try {
                    const audioBlob = new Blob(audioChunksRef.current, { type: mimeType });

                    // ── ElevenLabs STT REST call ──────────────────────────
                    const transcript = await elevenLabsSTT(audioBlob);

                    if (!transcript) {
                        setError("No speech detected. Please try again.");
                        setAppState("idle");
                        return;
                    }

                    setMessages(prev => [...prev, { role: "user", content: ` ${transcript}`, timestamp: Date.now() }]);
                    await runAIPipeline(transcript);
                } catch (err) {
                    console.error("STT error:", err);
                    setError("Transcription failed. Please try again or use text input.");
                    setAppState("idle");
                    setIsGenerating(false);
                }
            };

            mediaRecorder.start();
            setAppState("listening");
            setError(null);

        } catch (err) {
            console.error("Mic error:", err);
            if (err.name === "NotAllowedError") {
                setError("Microphone access denied. Please allow it in your browser settings.");
            } else if (err.name === "NotFoundError") {
                setError("No microphone found. Please connect one and try again.");
            } else {
                setError("Could not access microphone. Please try again.");
            }
            setAppState("idle");
        }
    }, [appState, isGenerating, runAIPipeline]);

    const handleMic = () => {
        if (appState === "listening") {
            stopRecording(); // triggers onstop → STT
        } else if (appState === "idle" && !isGenerating) {
            startListening();
        }
    };

    const handleStop = () => {
        stopRecording();
        cleanupTTS();
        window.speechSynthesis?.cancel();
        setAppState("idle");
        setIsGenerating(false);
    };

    const handleClose = () => { handleStop(); onClose(); };

    const busy = appState !== "idle" || isGenerating;

    return (
        <div
            className="relative flex flex-col overflow-hidden rounded-2xl nb-modal-in nb-font"
            style={{
                width: "min(900px, 95vw)",
                height: "min(620px, 90vh)",
                boxShadow: "0 8px 40px rgba(0,0,0,.3), 0 0 0 1px rgba(255,255,255,.1)"
            }}
        >

            <ModalBg state={appState} />

            {particles.map((p) => (
                <div
                    key={p.id}
                    className="absolute rounded-full pointer-events-none z-20"
                    style={{ width: p.size, height: p.size, background: "rgba(52,211,153,.7)", left: `${p.x}%`, bottom: "44%", animation: `nb-particle 1.8s ${p.delay}s ease-out infinite` }}
                />
            ))}

            {/* Header */}
            <header
                className="relative z-10 flex items-center justify-between px-6 py-4 shrink-0"
                style={{ borderBottom: "1px solid rgba(255,255,255,.07)" }}
            >
                <img src={logo2} alt="Logo" className="w-36 h-auto cursor-pointer hover:opacity-80 transition-opacity hidden md:block" />
                <div className="flex items-center gap-3">
                    <button onClick={handleClose}
                        className="flex items-center justify-center w-8 h-8 rounded-full transition-all duration-200"
                        style={{ background: "rgba(255,255,255,.06)", border: "1px solid rgba(255,255,255,.1)" }}
                        onMouseEnter={e => e.currentTarget.style.background = "rgba(239,68,68,.2)"}
                        onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,.06)"}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
                            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>
            </header>

            <div className="relative z-10 flex flex-1 overflow-hidden">
                {/* Left Panel */}
                <div className="flex flex-col items-center justify-between py-6 px-5 w-64 shrink-0" style={{ borderRight: "1px solid rgba(255,255,255,.06)" }}>
                    <div className="w-[16rem] h-[20rem]">
                        <CharacterDisplay loading={false} />
                    </div>
                    <div className="text-center mb-2">
                        <p className="text-xs font-medium transition-colors duration-300"
                            style={{ color: appState === "listening" ? "#ef4444" : appState === "thinking" ? "#f59e0b" : appState === "speaking" ? "#10b981" : "#94a3b8" }}>
                            {appState === "listening" ? "🔴 Recording… tap to stop"
                                : appState === "thinking" ? "⏳ Processing…"
                                    : appState === "speaking" ? "🔊 Speaking…"
                                        : "Tap mic to speak"}
                        </p>
                    </div>
                    <div className="flex flex-col items-center gap-4">
                        <MicBtn state={appState} onClick={handleMic} />
                        <button onClick={handleStop}
                            disabled={appState === "idle" && !isGenerating}
                            className="flex items-center justify-center rounded-full transition-all duration-200"
                            style={{ width: 44, height: 44, background: "rgba(255,255,255,.04)", border: "1px solid rgba(255,255,255,.07)", cursor: (appState === "idle" && !isGenerating) ? "not-allowed" : "pointer", opacity: (appState === "idle" && !isGenerating) ? 0.2 : 1 }}>
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#f87171" strokeWidth="2">
                                <rect x="6" y="6" width="12" height="12" rx="2" fill="rgba(239,68,68,.2)" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Right Panel - Chat */}
                <div className="flex-1 flex flex-col overflow-hidden">
                    <div className="flex-1 overflow-y-auto px-5 py-4 space-y-3"
                        style={{ scrollbarWidth: "thin", scrollbarColor: "rgba(255,255,255,.2) transparent" }}>
                        {messages.map((msg, idx) => (
                            <MessageBubble key={idx} role={msg.role} content={msg.content} />
                        ))}
                        {isGenerating && <MessageBubble role="assistant" content="" isStreaming={true} />}
                        <div ref={messagesEndRef} />
                    </div>

                    {error && (
                        <div className="mx-5 mb-2 px-3 py-2 rounded-lg bg-red-500/20 border border-red-500/30">
                            <p className="text-red-300 text-xs">{error}</p>
                        </div>
                    )}

                    <div className="p-4 border-t border-white/10">
                        <div className="flex gap-2 items-center">
                            <input ref={inputRef} value={inputVal}
                                onChange={e => setInputVal(e.target.value)}
                                onKeyDown={handleKeyPress}
                                placeholder={busy ? "Please wait..." : "Type your message here..."}
                                disabled={busy}
                                className="flex-1 h-14 px-4 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-[#B03982] focus:bg-white focus:outline-none transition-all duration-200 hover:border-[#B03982]/50" />
                            <button onClick={handleTextSubmit}
                                disabled={!inputVal.trim() || busy}
                                className="shrink-0 flex items-center justify-center rounded-xl px-5 h-14 bg-gradient-to-r from-[#B03982] to-[#733C86] text-white font-medium transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed hover:scale-105 active:scale-95">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" />
                                </svg>
                                <span className="ml-2 hidden sm:inline">Send</span>
                            </button>
                        </div>
                        <p className="text-slate-500 text-xs mt-2 text-center">
                            Powered by Nerdybuddy — tap mic, speak, tap again to transcribe
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

// ─── Main export ──────────────────────────────────────────────────────────────
export default function LiveChat() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const tag = document.createElement("style");
        tag.textContent = KEYFRAMES;
        document.head.appendChild(tag);
        return () => document.head.removeChild(tag);
    }, []);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);

    return (
        <>
            <div className="fixed bottom-5 right-5 z-50">
                <button onClick={() => setOpen(true)}
                    className="relative w-20 h-20 bg-gradient-to-br from-gray-900 to-gray-800 rounded-full flex items-center justify-center shadow-[0_8px_25px_rgba(0,0,0,0.3)] border border-white/20 hover:scale-110 active:scale-95 transition-all duration-300">
                    <span className="absolute inline-flex h-full w-full rounded-full bg-blue-500 opacity-20 animate-ping" />
                    <img src={logo} alt="Logo" className="w-12 relative z-10" />
                </button>
            </div>
            {open && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center p-4"
                    style={{ background: "rgba(0,0,0,.8)", backdropFilter: "blur(12px)" }}
                    onClick={e => { if (e.target === e.currentTarget) setOpen(false); }}
                >
                    <NerdyBuddyModal onClose={() => setOpen(false)} />
                </div>
            )}
        </>
    );
}